import Vue from "vue";
import VueRouter from "vue-router";
import LandingPage from "@/views/LandingPage";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            name: "LandingPage",
            component: LandingPage,
            props: route => ({
                // specific training params
                environment: route.query.environment,
                customer: route.query.customer,
                trainingName: route.query.training_name,
                // Monitored Mode params
                trainingId: route.query.training_id,
                scormId: route.query.scorm_id,
                employeeId: route.query.employee_id,
                productCertificationId: route.query.pc,
                baseUrl: route.query.base_url
            }),
            beforeEnter(routeTo, routeFrom, next) {
                // console.log('LANDING PAGE - re-routed', routeTo.query)
                next();
            }
        },
    ],
    // eslint-disable-next-line no-unused-vars
    scrollBehavior(to, from, savedPosition) {
        return {x: 0, y: 0};
    }
});

router.beforeEach((routeTo, routeFrom, next) => {
    // console.log('vue router to | from | next', routeTo, routeFrom, next)
    document.title = 'FLX | SCORM Player';
    next()
});

router.afterEach(() => {
});

export default router;
